// 供应商管理
<template>
    <div class="main">
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="icon iconfont icon-danju-xiugai-tianchong" style="margin-right:2px;"></i>
                        <span style="font-size:13px;">供应商信息</span>
                    </div>
                    <div class="search-content mar_b" style="margin-bottom:-15px;">
                        <el-form :inline="true" label-width="180px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                            <el-form-item prop="name" label="简称：">
                                <el-input v-model="query.name" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="rapid" label="RAPNET-ID：">
                                <el-input v-model="query.rapid" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item class="search-but" style="float:right">
                                <el-button type="primary" @click="selectList">查询</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item><br>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-button type="primary" @click="exportSelect" :disabled="isAble" size="small">导出选中</el-button>
                        <el-button type="primary" @click="exportAll" size="small">导出全部</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-table :data="suppliersInfoList" border  height='600px'
                            @selection-change="selectionLineChangeHandle"
                            ref="refTable" stripe
                            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                            <el-table-column type="selection" align="center" width="40"></el-table-column>
                            <el-table-column align="center" min-width="80" prop="vendor_no" label="编号"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="name" label="简称"></el-table-column>
                            <el-table-column align="center" min-width="120" prop="full_name" label="全称"></el-table-column>
                            <el-table-column align="center" min-width="80" prop="rapid" label="rapid"></el-table-column>
                            <el-table-column align="center" min-width="80" prop="rebate" label="折扣"></el-table-column>
                            <el-table-column align="center" min-width="80" prop="create_user" label="采购员"></el-table-column>
                            <el-table-column align="center" min-width="80" prop="place" label="国家/地区"></el-table-column>
                            <el-table-column align="center" min-width="80" prop="order_num" label="订货次数"></el-table-column>
                            <el-table-column align="center" min-width="130" prop="transactions" label="交易额"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="avg_day" label="平均到货(天)"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="upload_date" label="上次上传日期"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="upload_num" label="上次上传数量"></el-table-column>
                            <el-table-column align="center" min-width="80" prop="num_total" label="当前数量"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="data_date" label="数据日期"></el-table-column>
                            <!--
                            <el-table-column align="center" min-width="100" prop="caozuo" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini"
                                        @click="selectOrderList(scope.row)" >修改</el-button>
                                </template>
                            </el-table-column>
                            -->
                        </el-table>
                    </div>
                    <!--分页-->
                    <div class="block tar mar_t">
                        <div class="text e-info auto-table">
                            <span style='float:left;font-size:18px'> 已选：{{data_len}} </span>
                        </div>
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[20, 50, 100, 200]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../common/js/util';
    export default {
        data() {
            return {
                isAble: true,
                placeList: [{'value':'全部'},{'value':'HK'},{'value':'CHINA'},{'value':'SZ'}
                            ,{'value':'INDIA'},{'value':'LAB'},{'value':'SH'},{'value':'H-K'}],
                isq: '',
                inv_status: '',
                addDataForm: {},
                addDataForm3: {},
                dataOnLineListSelections: [],
                certnoList: [],
                certnoStr: '',
                suppliersInfoList: [],
                data_len: 0,
                sale_rap_total: 0,
                sale_usd_total: 0,
                sale_price_total: 0,
                // 查询
                query: {
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                    danhao: '1',
                    huiyuan: '1'
                },
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 20,
                    total: 0
                },
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectList();
            },
            // 选择器选择数据，加工数据证书号
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                //数据选中后，显示按钮
                if(val.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement("input");
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand("Copy");
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "复制成功",
                    type: "success",
                });
            },
            // 删除数据
            savaDataParams5() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                util.publicget('/order/deleteOrdersInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible8 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 修改订单数据
            savaDataParams() {
                let _this = this;
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/order/savaOrdersInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            stock_id: _this.addDataForm.stock_id,
                            cert_no: _this.addDataForm.cert_no,
                            id: _this.addDataForm.id,

                            rate: _this.addDataForm.rate,
                            back: _this.addDataForm.back,
                            status: _this.addDataForm.status,
                            received_type: _this.addDataForm.received_type,
                            price: _this.addDataForm.price,
                            received: _this.addDataForm.received,
                            remark: _this.addDataForm.remark
                        }, function (res) {
                            if (res.flag) {
                                _this.successMsg('本次操作成功！');
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // 前端处理 导出选中数据
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../common/js/Export2Excel.js')
                    const tHeader = ['编号','简称','全称', 'rapid', '折扣', '采购员'
                            , '国家/地区', '订货次数', '交易额', '平均到货(天)'
                            , '上次上传日期', '上次上传数量', '当前数量', '数据日期']
                    const filterVal = ['vendor_no','name','full_name', 'rapid', 'rebate', 'create_user'
                            ,'place', 'order_num', 'transactions', 'avg_day'
                            , 'upload_date' ,'upload_num', 'num_total', 'data_date' ]
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '供应商信息')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            // 导出全部数据
            exportAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../common/js/Export2Excel.js')
                    const tHeader = ['编号','简称','全称', 'rapid', '折扣', '采购员'
                            , '国家/地区', '订货次数', '交易额', '平均到货(天)'
                            , '上次上传日期', '上次上传数量', '当前数量', '数据日期']
                    const filterVal = ['vendor_no','name','full_name', 'rapid', 'rebate', 'create_user'
                            ,'place', 'order_num', 'transactions', 'avg_day'
                            , 'upload_date' ,'upload_num', 'num_total', 'data_date' ]
                    const list = this.suppliersInfoList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '供应商信息')
                })
            },
            // 加载订单信息分页列表
            selectList() {
                let _this = this;
                util.publicget('/order/querySuppliersInfoListPageModel', {
                    equalsName: _this.query.name,
                    equalsIphone: _this.query.iphone,
                    equalsRapid: _this.query.rapid,
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        _this.suppliersInfoList = res.obj;  
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            // 加载查询订单单条记录
            selectOrderList(rows) {
                let _this = this;
                util.publicget('/order/queryOrdersList', {
                    equalsId: rows.id,
                    equalsCert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.addDataForm = res.obj[0];
                            _this.dialogTableVisible10 = true;
                        }else {
                            _this.showMsg("该证书号数据不存在");
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.query = {};
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.start_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            }
        },
        mounted() {
            this.selectList();
        }
    };
</script>

<style lang="scss">
    /*
    ::v-deep .el-table__expand-icon {
        display: none !important;
    }*/
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
     /*:header-cell-style="{background:'#eee8aa'}"
    .el-table--border:after,
    .el-table--group:after,
    .el-table:before{
        background-color: #eee8aa
    }

    .el-table--border,
    .el-table--group{
        border-color: #eee8aa
    }

    .el-table td,
    .el-table th.is-leaf{
        border-bottom: #eee8aa
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type{
        border-bottom: #eee8aa
    }

    .el-table--border td,
    .el-table--border th{
        border-right: #eee8aa
    }
    */
</style>



// WEBPACK FOOTER //
// src/pages/suppliersInfoList.vue